import { createReducer } from '@reduxjs/toolkit';
import {
    DATA_SINGLE_ARTIST, SET_CURRENT_SLUG,
    SET_NOT_FOUND, SET_NEWS_SINGLE_ARTIST, SET_IS_RELATED_NEWS,
    IS_FETCHING_ARTIST_SINGLE,
} from '../actions/ArtistSingleActions';

const initialState = {
    dataArtistSingle: {},
    news: {},
    isFetching: false,
    currentSlug: null,
    notFound: false,
    isRelatedNews: false,
};

const artistSingle = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_CURRENT_SLUG, (state, action) => {
            state.currentSlug = action.slug;
        })
        .addCase(DATA_SINGLE_ARTIST, (state, action) => {
            state.dataArtistSingle = action.dataArtistSingle;
            state.isFetching = false;
        })
        .addCase(IS_FETCHING_ARTIST_SINGLE, (state, action) => {
            state.isFetching = action.data;
        })
        .addCase(SET_NOT_FOUND, (state, action) => {
            state.notFound = action.notFound;
        })
        .addCase(SET_NEWS_SINGLE_ARTIST, (state, action) => {
            state.news = action.news;
        })
        .addCase(SET_IS_RELATED_NEWS, (state, action) => {
            state.isRelatedNews = action.isRelatedNews;
        });
});

export default artistSingle;
